
import { Grid, Button, Select, MenuItem, FormControl, InputLabel, TextField } from '@mui/material'
import { useSelector } from 'react-redux'
// import { Ubi } from '../model'

export const SeccionComercial = ({ form, setForm, openMas, setOpenMas }) => {

    const { listaDeBancos, listaTiposDeCuenta } = useSelector(state => state.general)

    const handleChange = ({ target }) => {
        console.log(target.name, target.value)
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    return (
        <div style={{ marginTop: '10px' }}>

            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                <Grid item xs={12} sm={6}>
                    <div className='p-montos-mas-totales'>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Banco</InputLabel>
                            <Select
                                label="Banco"
                                id="id_banco"
                                name="id_banco"
                                value={form.id_banco || ''}
                                onChange={handleChange}
                                className='p-list-capitalize'
                            >
                                <MenuItem value={null} key={null}>Ninguno</MenuItem>
                                {listaDeBancos.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className='p-montos-mas-totales'>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de cuenta</InputLabel>
                            <Select
                                label="Tipo de cuenta"
                                id="banco_tipo_cuenta"
                                name="banco_tipo_cuenta"
                                value={form.banco_tipo_cuenta || ''}
                                onChange={handleChange}
                                className='p-list-capitalize'
                            >
                                <MenuItem value={null} key={null}>Ninguno</MenuItem>
                                {listaTiposDeCuenta.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='p-info'>
                        <TextField
                            label="Nro. cuenta"
                            name="banco_nro_cuenta"
                            id="banco_nro_cuenta"
                            value={form.banco_nro_cuenta || ''}
                            size="small"
                            fullWidth
                            placeholder="Ingrese número de cuenta"
                            onChange={handleChange}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='p-info'>
                        <TextField
                            label="CCI"
                            name="banco_nro_cci"
                            id="banco_nro_cci"
                            value={form.banco_nro_cci || ''}
                            size="small"
                            fullWidth
                            placeholder="Ingrese número CCI"
                            onChange={handleChange}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className='d-flex justify-content-end'>
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Guardar
                        </Button>
                    </div>
                </Grid>

            </Grid>

        </div>
    )
}